export const IMAGE_URL = process.env.REACT_APP_IMAGE_PATH || '/assets/images';
